import React from 'react';
import {Row,Col} from "react-bootstrap";

function LgShrink(props) {
    return (
        <Row className="d-flex justify-content-center">
            <Col xl={10}>
                {props.children}
            </Col>
        </Row>
    );
}

export default LgShrink;